import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';

import * as d3 from 'd3';
import {TemperatureUnit} from '../../../../shared';

@Component({
  selector: '[awair-indicator]',
  templateUrl: './indicator.component.html',
  styleUrls: ['./indicator.component.scss']
})

export class IndicatorComponent implements OnInit {

  @Input() temperatureUnit: TemperatureUnit;

  @Output() hoverEvent: EventEmitter<any> = new EventEmitter();
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
  @Output() outEvent: EventEmitter<any> = new EventEmitter();

  private isPinned: boolean = false;
  private indicatorGroup: any;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.indicatorGroup = d3.select(this.el.nativeElement)
      .style('display', 'none');

    this.indicatorGroup.append('line')
      .attr('class', 'indicator-line')
      .attr('stroke-width', '1px')
      // To prevent blinking
      .style('pointer-events', 'none');
  }

  positionIndicatorList(relativePosList: Array<{ x: number, y: number }>, colorScale: any, type: string,
    indicatorHeight: number, yValList: number[]): void {

    // Remove all previously plotted dots
    d3.select(this.el.nativeElement).selectAll('circle').remove();

    this.indicatorGroup.style('display', null);

    for (let i = 0; i < relativePosList.length; i++) {
      // There should be no dot if y value is null
      if (relativePosList[i] && relativePosList[i].y != null) {
        // Consider fahrenheit color
        const indicatorColor: string = (type === 'temp' && this.temperatureUnit === TemperatureUnit.Fahrenheit) ?
          colorScale(this.fahrenheitToCelsius(yValList[i])) : colorScale(yValList[i]);
        this.indicatorGroup.append('circle')
          .attr('class', 'indicator-circle')
          .attr('r', 3.5)
          .style('fill', indicatorColor)
          .attr('transform', 'translate(' + relativePosList[i].x + ',' + relativePosList[i].y + ')')
          // To prevent blinking
          .style('pointer-events', 'none');

        // Indicator dot event listener
        this.indicatorGroup.append('circle')
          .attr('class', 'indicator-circle')
          .attr('r', 6)
          .style('fill', 'transparent')
          .style('cursor', 'pointer')
          .attr('transform', 'translate(' + relativePosList[i].x + ',' + relativePosList[i].y + ')')
          .on('mousemove', (d) => {
            this.hoverEvent.emit({ relativePos: relativePosList[i], deviceIndex: i, value: yValList[i] });
          })
          .on('click', () => {
            this.clickEvent.emit({ relativePos: relativePosList[i], deviceIndex: i, value: yValList[i] });
          })
          .on('mouseout', () => {
            this.outEvent.emit();
          });
      }
    }

    const filteredPosList = relativePosList.filter(pos => pos != null);

    this.indicatorGroup
      .select('.indicator-line')
      .style('stroke', '#ACB4BB')
      .style('stroke-opacity', 0.5)
      .attr('x1', filteredPosList[0].x)
      .attr('y1', 0)
      .attr('x2', filteredPosList[0].x)
      .attr('y2', indicatorHeight);
  }

  pinIndicator(): void {
    this.isPinned = true;
    this.indicatorGroup
      .select('.indicator-line')
      .style('stroke-opacity', 1);
  }

  unpinIndicator(): void {
    this.isPinned = false;
    if (this.indicatorGroup != null) {
      this.indicatorGroup
        .select('.indicator-line')
        .style('stroke-opacity', 0.3);
    }
  }

  removeIndicator(): void {
    if (this.indicatorGroup) { this.indicatorGroup.style('display', 'none'); }
  }

  private fahrenheitToCelsius(fahValue: number): number {
    const celsius = (fahValue - 32) / 1.8;
    return Number(celsius.toFixed(2));
  }
}
